import { MapPin } from 'lucide-react'
import SectionLabel from '@/components/ui/SectionLabel'
import { useContent, useLiens } from '@/hooks/useContent'
import { mapsEmbedUrl } from '@/helpers/liens'

export default function AdresseSection() {
  const { contact } = useContent()
  const liens = useLiens()
  return (
    <section id="adresse" className="py-16 md:py-20 px-4 bg-white">
      <div className="max-w-lg md:max-w-5xl mx-auto">
        <SectionLabel>Où nous trouver</SectionLabel>
        <h2 className="text-2xl md:text-3xl font-bold text-cmp-navy text-center mt-3 mb-8 md:mb-10">Notre adresse</h2>

        <div className="lg:grid lg:grid-cols-2 lg:items-stretch">
          <div
            className="relative rounded-t-3xl lg:rounded-tr-none lg:rounded-l-3xl overflow-hidden ring-1 ring-cmp-navy/5"
            style={{
              backgroundImage:
                'linear-gradient(#e2e8f0 1px, transparent 1px), linear-gradient(90deg, #e2e8f0 1px, transparent 1px)',
              backgroundSize: '28px 28px',
              backgroundColor: '#f8fafc',
            }}
            aria-hidden="true"
          >
            <div className="lg:absolute inset-0 flex items-center justify-center">
                <iframe
                  title="Carte de l'église"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  loading="lazy"
                  src={mapsEmbedUrl(contact.lat, contact.lng)}
                />
            </div>
          </div>

          <div className="bg-cmp-sky-light rounded-b-3xl lg:rounded-bl-none lg:rounded-r-3xl p-6 md:p-8 ring-1 ring-cmp-navy/5 flex flex-col justify-center">
            <div className="flex items-start gap-4">
              <div className="w-11 h-11 bg-cmp-navy rounded-full flex items-center justify-center shrink-0 shadow-md shadow-cmp-navy/20">
                <MapPin size={20} color="white" />
              </div>
              <div>
                <p className="font-bold text-cmp-navy">CMP Lubumbashi</p>
                <p className="text-gray-600 text-sm mt-1 leading-relaxed">{contact.adresse}</p>
                {contact.repere && <p className="text-gray-500 text-xs mt-1">{contact.repere}</p>}
              </div>
            </div>

            <a
              href={liens.maps}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 flex items-center justify-center gap-2 bg-cmp-navy text-white font-bold rounded-full py-3.5 px-6 text-sm w-full shadow-md shadow-cmp-navy/20 hover:bg-cmp-navy-light transition-colors active:scale-95"
            >
              <MapPin size={16} />
              Ouvrir l'itinéraire
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}
